module.exports = __webpack_public_path__ + "img/icon-meteo-5@2x.aa6fee51.png";